// extracted by mini-css-extract-plugin
export default {"wrapper":"AdsContainer_wrapper__8agZ6","ad":"AdsContainer_ad__HpQx5"};